// services/cloudinaryService.js

import { api } from "../config/api";

export const uploadAvatar = async (userId, file) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post(
        `/cloudinary/${userId}/avatar`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data; // { url }
};

export const uploadDocument = async (userId, file, documentType, side) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post(
        `/cloudinary/${userId}/document?documentType=${documentType}&side=${side}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data; // { url }
};